<template>
  <div>
    <div class="login-header">
      <div class="title">{{ title }}</div>
      <div>pawaMatch</div>
    </div>
    <div class="dx-field">
      <dx-button
        styling-mode="outlined"
        type="default"
        text="Login"
        width="100%"
        @click="onLoginClick"
      />
    </div>
  </div>
</template>

<script>
import DxButton from 'devextreme-vue/button'
import { config } from '../config'
import { get } from 'lodash'

const prefix = process.env.NODE_ENV === 'production' ? '' : '/api'
const oauthRedirect = window.location.origin + '/oauth2/redirect'
const googleAuth =
  prefix + '/oauth2/authorization/azure?redirect_uri=' + oauthRedirect

export default {
  components: {
    DxButton,
  },
  data() {
    return {
      title: config.title,
      login: '',
      password: '',
      rememberUser: false,
    }
  },
  created() {
    const redirect = get(this.$route, 'query.redirect')
    if (redirect) {
      this.$cookies.set(
        config.redirectCookie,
        redirect,
        config.redirectExpirationTime,
      )
    }
  },
  methods: {
    onLoginClick() {
      localStorage.clear()
      window.location.href = googleAuth
    },
  },
}
</script>

<style lang="scss">
@import '../themes/generated/variables.base.scss';

.login-header {
  text-align: center;
  margin-bottom: 40px;

  .title {
    color: $base-accent;
    font-weight: bold;
    font-size: 30px;
    margin: 0;
  }
}
</style>
